import {
	Button,
	ButtonGroup,
	Flex,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Spinner,
	Text,
	useDisclosure,
} from '@chakra-ui/react';
import { IconDotsVertical } from '@tabler/icons';
import { AlertComponent } from 'components/alerts/AlertComponent';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import ExportGenericCSVButton from 'components/buttons/exportButtons/ExportGenericCSVButton';
import Card from 'components/card/Card';
import CheckTable from 'components/dataTables/CheckTable';
import CheckTableModal from 'components/modal/CheckTableModal';
import { FileUploadModal } from 'components/modal/fileUpload/FileUploadModal';
import { TooltipStandard } from 'components/tooltip/TooltipStandard';
import { useGlobalContext } from 'contexts/GlobalContext';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFamilyListAll } from 'services/queryClient/wrapperHooks/family/useFamilyListAll';
import { useProductNotFamilyList } from 'services/queryClient/wrapperHooks/product/useProductNotFamilyList';
import { useDownloadTemplateProduct } from 'services/queryClient/wrapperHooks/uploads/useDownloadTemplateProduct';
import { useUploadProducts } from 'services/queryClient/wrapperHooks/uploads/useUploadProducts';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';
import { formatStringoToDateAndTime } from 'utils/functions/dateUtils';

import { buildCheckTableModalProps } from '../familia/functions/util';
import ModalDelete from '../familia/modalDelete';
import ModalRegisterEditFamily from '../familia/modalRegisterEditFamily';
import { columnsDataProduct } from './variables/columnsDataProduct';
interface IProducts {
	codigo_produto: string;
	empresa_id: number;
	nome_familia: string;
	familia_id: number;
	id: number;
	nome_produto: string;
	custo: number;
	status: boolean;
	nome_sub_familia: string;
	nome_modelo_produto: string;
	participa_rateio: boolean;
	data_registro: string;
}

export default function CadastroProdutos() {
	const { isOpen, onOpen, onClose } = useDisclosure();

	const history = useHistory();

	const { pathCompanyName } = useGlobalContext();

	const { setters } = useContext(SidebarHelpContext);

	const { setDataSidebar } = setters;

	const tableColumns = useMemo(() => columnsDataProduct, []);

	const [hasBaseData, setHasBaseData] = useState<boolean>(false);

	const {
		isOpen: isOpenModalList,
		onOpen: onOpenModalList,
		onClose: onCloseModalList,
	} = useDisclosure();

	const [selectedModuleProps, setSelectedModuleProps] = useState<any>({});

	const {
		isOpen: isOpenDeleteModal,
		onOpen: onOpenDeleteModal,
		onClose: onCloseDeleteModal,
	} = useDisclosure();

	const [deleteId, setDeleteId] = useState<string | number>('');
	const [deleteType, setDeleteType] = useState<
		'family' | 'subFamily' | 'productModel'
	>('family');
	const [isOpenCreateModal, setIsOpenCreateModal] = useState(false);
	const [createModalType, setCreateModalType] = useState<
		'family' | 'subFamily' | 'productModel'
	>('family');
	const [searchTerm, setSearchTerm] = useState<string>('');
	const [isProcessing, setIsProcessing] = useState<boolean>(() => {
		return !!localStorage.getItem('product-upload-processing');
	});

	const helpProducts: ISidebarHelp = useMemo(
		() => ({
			title: 'Produtos',
			firstParagraph:
				'Nesta tela é possível visualizar todos os Produtos (por código) do seu negócio.  Note que todos os produtos devem pertencer a alguma família de produto.',
			secondParagraph:
				'Utilize o botão de “Rateio” da tabela para indicar se o produto participa ou não do rateio de vendas, e assim da previsão da demanda. Ao ativar o botão, você indica que ele participa do rateio.',
			thirdParagraph:
				'Acesse o botão “Cadastrar Produto” para adicionar novos produtos ou importe um arquivo de produtos acessando “Importar Produto”.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	const dataDelete = useMemo(
		() => ({
			provider: 'product',
			toastSuccessTitle: 'Excluido com sucesso!',
			toastSuccessDescription: 'O produto foi excluido com sucesso.',
			toastErrorTitle: 'Erro ao excluir produto!',
			title: 'Deseja realmente excluir este produto?',
			toastProcessingTitle: 'Processando solicitação...',
			toastProcessingDescription:
				'Processando a solicitação, aguarde o e-mail de confirmação.',
			text: [
				'Você está prestes a excluir este produto da sua base de cadastros. Excluir este produto resultará na remoção dos seguintes itens vinculados a ele:',
				'REPLACE_ME',
				'Você tem certeza que deseja excluir?',
			],
			invalidate: 'produto-list',
		}),
		[]
	);

	const deleteMessage = useMemo(
		() => [
			'Você está prestes a excluir estes produtos da sua base de cadastros. Excluir estes produtos resultará na remoção dos seguintes itens vinculados a ele:',
			'REPLACE_ME',
		],
		[]
	);

	const dataDeleteAll = useMemo(
		() => ({
			provider: 'product',
			toastSuccessTitle: 'Registros excluídos com sucesso!',
			toastSuccessDescription: 'Os produtos foram excluídos com sucesso',
			toastErrorTitle: 'Erro ao excluir produtos!',
			toastProcessingTitle: 'Processando solicitação...',
			toastProcessingDescription:
				'Processando a solicitação, aguarde o e-mail de confirmação.',
			invalidate: 'produto-list',
		}),
		[]
	);

	const { data: productNotFamilyData } = useProductNotFamilyList();

	const { data: familyData } = useFamilyListAll();

	const subFamilyData = useMemo(() => {
		if (!familyData) return [];
		return familyData.flatMap(
			family =>
				family.sub_familia?.map(sub => ({
					...sub,
					nome_familia: family.nome_familia,
					data_registro: sub.createdAt || sub.updatedAt,
				})) || []
		);
	}, [familyData]);

	const modelData = useMemo(() => {
		if (!familyData) return [];
		return familyData.flatMap(
			family =>
				family.sub_familia?.flatMap(
					sub =>
						sub.modelo?.map(model => ({
							...model,
							nome_familia: family.nome_familia,
							nome_sub_familia: sub.nome_sub_familia,
							data_registro: model.createdAt || model.updatedAt,
						})) || []
				) || []
		);
	}, [familyData]);

	const goToCadastroProdutos = useCallback(() => {
		history.push(`/${pathCompanyName}/cadastros/produto/criar`);
	}, [history, pathCompanyName]);

	const handleDelete = useCallback(
		(id: number, type: 'family' | 'subFamily' | 'productModel') => {
			if (type === 'family') {
				const familyHasProducts = productNotFamilyData?.some(
					product => product.familia_id === id
				);

				if (familyHasProducts) {
					alert(
						'Não é possível excluir esta família pois ela possui produtos vinculados.'
					);
					return;
				}
			}

			setDeleteId(id);
			setDeleteType(type);
			onOpenDeleteModal();
		},
		[onOpenDeleteModal, productNotFamilyData]
	);

	const handleOnOpenModalList = useCallback(
		module => {
			let data = [];
			let onDelete: ((id: number) => void) | null = null;

			switch (module) {
				case 'família':
					data = (familyData || []).filter(
						item =>
							!searchTerm ||
							item.nome_familia
								.toLowerCase()
								.includes(searchTerm.toLowerCase())
					);
					onDelete = id => handleDelete(id, 'family');
					break;
				case 'subfamília':
					data = (subFamilyData || []).filter(
						item =>
							!searchTerm ||
							item.nome_sub_familia
								.toLowerCase()
								.includes(searchTerm.toLowerCase())
					);
					onDelete = id => handleDelete(id, 'subFamily');
					break;
				case 'modelo':
					data = (modelData || []).filter(
						item =>
							!searchTerm ||
							item.nome_modelo
								.toLowerCase()
								.includes(searchTerm.toLowerCase())
					);
					onDelete = id => handleDelete(id, 'productModel');
					break;
			}
			const handleCreateClick = () => {
				switch (module) {
					case 'família':
						setCreateModalType('family');
						break;
					case 'subfamília':
						setCreateModalType('subFamily');
						break;
					case 'modelo':
						setCreateModalType('productModel');
						break;
				}
				setIsOpenCreateModal(true);
			};
			setSelectedModuleProps(
				buildCheckTableModalProps(
					module,
					data,
					onDelete,
					handleCreateClick
				)
			);
			setTimeout(() => onOpenModalList(), 300);
		},
		[
			onOpenModalList,
			familyData,
			subFamilyData,
			modelData,
			handleDelete,
			searchTerm,
		]
	);

	const renderRow = useCallback((product: IProducts) => {
		return {
			empresa_id: product.empresa_id,
			id:
				product.status === true
					? [product.id, false]
					: [product.id, true],
			produto: product.nome_produto,
			codigo_produto: product.codigo_produto,
			custo:
				product?.custo >= 0
					? product?.custo?.toLocaleString?.('pt-BR', {
							style: 'currency',
							currency: 'BRL',
					  })
					: '',
			familia_id: product.familia_id,
			familia: product?.nome_familia || '',
			subfamilia: product?.nome_sub_familia || '',
			nomeModeloProduto: product?.nome_modelo_produto || '',
			status: product.status === true ? 'Ativo' : 'Inativo',
			rateio: product.participa_rateio,
			dataRegistro: formatStringoToDateAndTime(product?.data_registro),
		};
	}, []);

	const renderMenuListOptions = useCallback(() => {
		return (
			<Menu>
				<MenuButton
					as={Button}
					rightIcon={
						<Flex mr='6px'>
							<IconDotsVertical />
						</Flex>
					}
					size='large'
					fontWeight='100'
					px='6px'
					py='2px'
					border='1px solid'
					borderRadius='100px'
					borderColor='easyBrandMenu.200'
					fontSize='16px'
					color='easyBLUE.300'
					_hover={{ bg: '#FAFCFE' }}
					_focus={{ bg: 'white' }}
					_active={{ bg: '#E2E8F0', boxShadow: 'none' }}
				/>
				<MenuList>
					<MenuItem onClick={() => handleOnOpenModalList('família')}>
						<Text color='easyBLUE.300'>Ver famílias</Text>
					</MenuItem>
					<MenuItem
						onClick={() => handleOnOpenModalList('subfamília')}
					>
						<Text color='easyBLUE.300'>Ver subfamílias</Text>
					</MenuItem>
					<MenuItem onClick={() => handleOnOpenModalList('modelo')}>
						<Text color='easyBLUE.300'>Ver modelos</Text>
					</MenuItem>
				</MenuList>
			</Menu>
		);
	}, [handleOnOpenModalList]);

	const renderButtons = useCallback(() => {
		return (
			<Flex
				flexDirection={'row'}
				justifyContent={'flex-end'}
				mt={'20px'}
				me={'20px'}
				mb={'40px'}
			>
				<ButtonGroup spacing={'20px'}>
					{isProcessing ? (
						<TooltipStandard label='Aguarde o processamento terminar para fazer um novo upload'>
							<ButtonComponent
								data-test='button-importar-produtos'
								type={'ghost'}
								title={'Importar Produtos'}
								onClick={onOpen}
								isDisabled={isProcessing}
							/>
						</TooltipStandard>
					) : (
						<ButtonComponent
							data-test='button-importar-produtos'
							type={'ghost'}
							title={'Importar Produtos'}
							onClick={onOpen}
							isDisabled={isProcessing}
						/>
					)}
					<FileUploadModal
						isOpen={isOpen}
						onClose={onClose}
						headerText={'Importar Produtos'}
						module={'produto'}
						useDownloadTemplate={useDownloadTemplateProduct}
						stringInvalidQuery='produto-list'
						useUpload={useUploadProducts}
						showLineRestricts={true}
						columnsData={tableColumns}
						hasBaseData={hasBaseData}
					/>
					<ButtonComponent
						data-test='button-cadastrar-produtos'
						type={'primary'}
						title={'Cadastrar Produtos'}
						onClick={goToCadastroProdutos}
					/>
					<TooltipStandard label='Exportar Produtos para CSV'>
						<ExportGenericCSVButton
							module={'produto'}
							nameExport='produtos'
							errorDescription='Não há produtos para exportar!'
						/>
					</TooltipStandard>
					{renderMenuListOptions()}
				</ButtonGroup>
			</Flex>
		);
	}, [
		goToCadastroProdutos,
		hasBaseData,
		isOpen,
		onClose,
		onOpen,
		tableColumns,
		renderMenuListOptions,
		isProcessing,
	]);

	const renderTable = useCallback(
		() => (
			<CheckTable
				dataTest='button-filtrar-produtos'
				module={'Produtos'}
				linkEditForm={`/${pathCompanyName}/cadastros/produto/editar`}
				columnsData={tableColumns}
				dataDelete={dataDelete}
				deleteMessage={deleteMessage}
				showGenericSearchInput={false}
				filterModule='produto'
				bulkDeleteProps={dataDeleteAll}
				renderRow={renderRow}
				setHasBaseData={setHasBaseData}
				setAlertUpdate={() => {}}
			/>
		),
		[
			dataDelete,
			dataDeleteAll,
			deleteMessage,
			pathCompanyName,
			renderRow,
			tableColumns,
		]
	);

	useEffect(() => {
		setDataSidebar(helpProducts);
	}, [helpProducts, setDataSidebar]);

	useEffect(() => {
		const checkProcessingStatus = () => {
			const processingTimestamp = localStorage.getItem(
				'product-upload-processing'
			);
			setIsProcessing(!!processingTimestamp);
		};

		checkProcessingStatus();

		const interval = setInterval(checkProcessingStatus, 1000);

		const handleStorageChange = (e: StorageEvent) => {
			if (e.key === 'product-upload-processing') {
				checkProcessingStatus();
			}
		};

		const handleCustomEvent = () => {
			setTimeout(() => {
				checkProcessingStatus();
			}, 0);
		};

		window.addEventListener('storage', handleStorageChange);
		window.addEventListener(
			'product-upload-processing-changed',
			handleCustomEvent
		);

		return () => {
			clearInterval(interval);
			window.removeEventListener('storage', handleStorageChange);
			window.removeEventListener(
				'product-upload-processing-changed',
				handleCustomEvent
			);
		};
	}, []);

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='0px'>
				<Flex
					pl={5}
					pr={5}
					w={'100%'}
					direction={'column'}
				>
					{isProcessing && (
						<AlertComponent
							title='Processamento em andamento:'
							description='As atualizações ocorrem em etapas. A tabela será atualizada automaticamente até que tudo esteja finalizado.'
							status={'info'}
							icon={
								<Spinner
									size='md'
									thickness='4px'
									speed='0.65s'
									color='easyBLUE.300'
									marginRight='10px'
								/>
							}
						/>
					)}
					{productNotFamilyData &&
						productNotFamilyData.length > 0 && (
							<AlertComponent
								title='Atenção!'
								description='Existem produtos cadastrados sem famílias. Necessário corrigir!'
								status={'warning'}
								hasCloseButton
							/>
						)}
				</Flex>

				{renderButtons()}
				{renderTable()}
			</Card>
			<CheckTableModal
				filterModule={selectedModuleProps?.filterModule}
				columnsData={selectedModuleProps?.columnsData}
				renderRow={selectedModuleProps?.renderRow}
				isOpen={isOpenModalList}
				onClose={onCloseModalList}
				modalTitle={selectedModuleProps?.modalTitle}
				simpleDelete={selectedModuleProps?.simpleDelete}
				deleteMany={selectedModuleProps?.deleteMany}
				deleteAll={selectedModuleProps?.deleteAll}
				queriesToInvalidadeOnRemove={['family-list', 'produto-list']}
				queriesToInvalidadeOnEdit={['family-list', 'produto-list']}
				modalIcon={selectedModuleProps?.modalIcon}
				modalIconColor={selectedModuleProps?.modalIconColor}
				modalTitleColor={selectedModuleProps?.modalTitleColor}
				showCreateButton={selectedModuleProps?.showCreateButton}
				createButtonText={selectedModuleProps?.createButtonText}
				onCreateClick={selectedModuleProps?.onCreateClick}
			/>
			<ModalRegisterEditFamily
				type={createModalType}
				isOpen={isOpenCreateModal}
				onClose={() => setIsOpenCreateModal(false)}
				autocompleteAdditionalData={{}}
			/>
			<ModalDelete
				type={deleteType}
				isOpen={isOpenDeleteModal}
				onClose={onCloseDeleteModal}
				removeId={deleteId}
			/>
		</Flex>
	);
}
